import React from "react";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deactivateAccount } from "../../actions/user";

const DeactivateAccountModal = ({ hideModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDeacitivateAccount = () => {
    dispatch(deactivateAccount(navigate));
    hideModal();
  };

  return (
    <div className="deactivate-modal-holder">
      <div className="deactivate-modal-title">
        <h1>{t("deactivateAccount.deactivateTitle")}</h1>
        <div className="deactivate-modal-close-icon" onClick={hideModal}>
          <img src="/images/close.png" alt="" className="img-fluid" />
        </div>
      </div>
      <div className="deactivate-modal-container">
        <div className="deactivate-modal-message">
          {t("deactivateAccount.deactivateQuestion")}
        </div>
        <div className="deactivate-modal-actions">
          <button className="deactivate-btn cancel-deactivation" onClick={hideModal}>
            {t("deactivateAccount.cancel")}
          </button>
          <button className="deactivate-btn confirm-deactivation" onClick={handleDeacitivateAccount}>
            {t("deactivateAccount.confirmDeactivate")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateAccountModal;
